import api from '@/api';
import { ActionsTree, ListStatus, ErrorMessages, RootActions } from '@/store/types';
import { BannerStandOrdersState, BannerStandOrdersActions, BannerStandOrdersMutations } from './types';
import BannerStandOrder from './banner-stand-order';
import Pagination from '@/store/models/pagination';
import { enhanceErrorWithMessage } from '@/utils/errors';

export const actions: ActionsTree<BannerStandOrdersState, typeof BannerStandOrdersActions> = {
  [BannerStandOrdersActions.LOAD_LIST]({ commit, dispatch }, options): Promise<void> {
    commit(BannerStandOrdersMutations.SET_LIST_STATUS, ListStatus.Loading);

    return api.bannerStandImages
      .listOrders(options)
      .then((response) => {
        commit(BannerStandOrdersMutations.SET_LIST_PAGINATION, Pagination.fromJSON(response.data));
        commit(
          BannerStandOrdersMutations.SET_LIST,
          response.data.data.map((item: any) => BannerStandOrder.fromJSON(item)),
        );
        commit(BannerStandOrdersMutations.SET_LIST_STATUS, ListStatus.Loaded);
      })
      .catch((error) => {
        enhanceErrorWithMessage(error, ErrorMessages.DATA_LOAD_ERROR);
        commit(BannerStandOrdersMutations.SET_LIST_STATUS, ListStatus.Failed);
        return dispatch(RootActions.ERROR, error, { root: true });
      });
  },

  [BannerStandOrdersActions.LOAD_ORDER]({ commit, dispatch }, { id }): Promise<void> {
    return api.bannerStandImages
      .getOrder(id)
      .then((response) => {
        const order = BannerStandOrder.fromJSON(response.data);
        commit(BannerStandOrdersMutations.SET_CURRENT, order);
      })
      .catch((error) => {
        enhanceErrorWithMessage(error, ErrorMessages.DATA_LOAD_ERROR);
        return dispatch(RootActions.ERROR, error, { root: true });
      });
  },
};

export default actions;
